/* assets/cart-drawer-progress.js */
(function () {
  var mountId = "CartDrawerProgress";

  /* -----------------------------
     EDIT THESE (promo + labels)
  ------------------------------ */

  var CONFIG = {
    // USD tiers (minor units)
    USD_SHIP_CENTS: 10000,  // $100.00
    USD_MODEL_CENTS: 20000, // $200.00

    // Labels under the bar
    labelShip: "Free Shipping",
    labelModel: "Free Model",

    // Messages above the bar
    // tokens: {shipRemaining}, {modelRemaining}, {labelShip}, {labelModel}
    msgBeforeShip: "{shipRemaining} left for {labelShip}",
    msgAfterShipBeforeModel: "{labelShip} unlocked - {modelRemaining} left for {labelModel}",
    msgAfterModel: "{labelModel} unlocked"
  };

  // Fixed anchor (Starter Kit variant)
  var ANCHOR_VARIANT_ID = 50336159203633;

  // Cache/versioning
  var CACHE_VERSION = "v8";
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours

  // Approved currencies for FREE MODEL
  var APPROVED_MODEL_CURRENCIES = {
    USD: true,
    EUR: true,
    GBP: true,
    AUD: true,
    CAD: true,
    NZD: true,
    CHF: true,
    SEK: true,
    NOK: true,
    DKK: true,
    PLN: true,
    CZK: true,
    HUF: true,
    RON: true,
    BGN: true,
    JPY: true,
    SGD: true,
    HKD: true,
    MXN: true
  };

  // Icon SVGs (inline, no external assets)
  var ICON_TRUCK =
    '<svg class="cdp-icon" viewBox="0 0 24 24" aria-hidden="true">' +
    '  <path d="M3 6h11v9H3V6zm12 3h3l3 3v3h-6V9zm-9 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>' +
    "</svg>";

  var ICON_GIFT =
    '<svg class="cdp-icon" viewBox="0 0 24 24" aria-hidden="true">' +
    '  <path d="M20 7h-2.1a3 3 0 0 0 .1-.7C18 4.5 16.5 3 14.7 3c-1.1 0-2.2.6-2.7 1.6C11.5 3.6 10.4 3 9.3 3 7.5 3 6 4.5 6 6.3c0 .2 0 .5.1.7H4v4h16V7zM9.3 5c.8 0 1.5.7 1.5 1.5V7H8.5c-.8 0-1.5-.7-1.5-1.5S7.7 5 9.3 5zm5.4 0c1.6 0 2.3.7 2.3 1.5S16.3 7 15.5 7H13.2v-.5c0-.8.7-1.5 1.5-1.5zM4 13h7v8H4v-8zm9 0h7v8h-7v-8z"/>' +
    "</svg>";

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function formatMoneyIntl(cents, iso) {
    var value = cents / 100;
    try {
      if (iso) return new Intl.NumberFormat(undefined, { style: "currency", currency: iso }).format(value);
    } catch (e) {}
    return value.toFixed(2);
  }

  function template(str, vars) {
    return String(str || "").replace(/\{([a-zA-Z0-9_]+)\}/g, function (m, key) {
      if (vars && Object.prototype.hasOwnProperty.call(vars, key)) return String(vars[key]);
      return m;
    });
  }

  function getSfConfig() {
    var sf = window.BLKOUT_SF || {};
    return {
      shopDomain: (typeof sf.shopDomain === "string" && sf.shopDomain) ? sf.shopDomain : "",
      token: (typeof sf.token === "string" && sf.token) ? sf.token : "",
      country: (typeof sf.country === "string" && sf.country) ? sf.country : "US",
      language: (typeof sf.language === "string" && sf.language) ? sf.language : "EN",
      currency: (typeof sf.currency === "string" && sf.currency) ? sf.currency : ""
    };
  }

  function cartCurrency(cart) {
    if (cart && typeof cart.currency === "string" && cart.currency) return cart.currency;
    return "USD";
  }

  function currencyToCountry(iso) {
    var map = {
      USD: "US",
      GBP: "GB",
      EUR: "DE",
      CAD: "CA",
      AUD: "AU",
      NZD: "NZ",
      CHF: "CH",
      SEK: "SE",
      NOK: "NO",
      DKK: "DK",
      PLN: "PL",
      CZK: "CZ",
      HUF: "HU",
      RON: "RO",
      BGN: "BG",
      JPY: "JP",
      SGD: "SG",
      HKD: "HK",
      MXN: "MX"
    };
    if (map[iso]) return map[iso];
    return "US";
  }

  function toGidVariant(variantId) {
    return "gid://shopify/ProductVariant/" + String(variantId);
  }

  function sfFetchPrice(shopDomain, token, country, language, gidVariant) {
    var endpoint = "https://" + shopDomain + "/api/2024-07/graphql.json";

    var query =
      "query VariantPrice($id: ID!) @inContext(country: " + country + ", language: " + language + ") {" +
      "  node(id: $id) {" +
      "    ... on ProductVariant {" +
      "      price { amount currencyCode }" +
      "    }" +
      "  }" +
      "}";

    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify({ query: query, variables: { id: gidVariant } }),
      credentials: "omit"
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.errors && json.errors.length) {
          throw new Error("SF errors: " + JSON.stringify(json.errors));
        }
        var node = json && json.data && json.data.node;
        var price = node && node.price;
        var amount = price && typeof price.amount === "string" ? parseFloat(price.amount) : NaN;
        var code = price && price.currencyCode ? String(price.currencyCode) : "";
        if (!isFinite(amount) || amount <= 0) throw new Error("Bad price response");
        return { amount: amount, currencyCode: code };
      });
  }

  function computePresentmentRate(targetCurrencyIso) {
    var sf = getSfConfig();
    if (!sf.shopDomain || !sf.token) return Promise.reject(new Error("Missing SF config"));

    var gid = toGidVariant(ANCHOR_VARIANT_ID);
    var targetCountry = currencyToCountry(targetCurrencyIso);
    var lang = (sf.language || "EN").toUpperCase();

    return Promise.all([
      sfFetchPrice(sf.shopDomain, sf.token, "US", lang, gid),
      sfFetchPrice(sf.shopDomain, sf.token, targetCountry, lang, gid)
    ]).then(function (res) {
      var us = res[0];
      var local = res[1];

      var localCode = local.currencyCode ? String(local.currencyCode) : "";
      if (!localCode || localCode !== targetCurrencyIso) {
        throw new Error("Unsupported currency: expected " + targetCurrencyIso + " got " + localCode);
      }

      var rate = local.amount / us.amount;
      if (!isFinite(rate) || rate <= 0) throw new Error("Bad rate");

      return {
        rate: rate,
        localCurrency: localCode,
        targetCountry: targetCountry,
        anchorVariantId: ANCHOR_VARIANT_ID
      };
    });
  }

  function floorToDollar(cents) {
    return Math.floor(cents / 100) * 100;
  }

  // PRE-discount total (matches gift app logic)
  function sumOriginalPreDiscount(cart) {
    if (!cart || !cart.items) return 0;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (typeof it.original_line_price === "number") sum += it.original_line_price;
    }
    return sum;
  }

  // POST-discount total (matches free shipping threshold logic)
  function totalPostDiscount(cart) {
    if (cart && typeof cart.total_price === "number") return cart.total_price;
    return 0;
  }

  function hideBar(el) {
    if (!el) return;
    el.style.display = "none";
  }

  function showBar(el) {
    if (!el) return;
    el.style.display = "";
  }

  function readCachedGoal(iso) {
    if (!CACHE_TTL_MS) return null;

    var key = "blkout_goal_model_" + CACHE_VERSION + "_" + iso;
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj.goalCents !== "number" || typeof obj.ts !== "number") return null;
      if ((Date.now() - obj.ts) > CACHE_TTL_MS) return null;
      if (!isFinite(obj.goalCents) || obj.goalCents <= 0) return null;
      return obj.goalCents;
    } catch (e) {
      return null;
    }
  }

  function writeCachedGoal(iso, goalCents) {
    if (!CACHE_TTL_MS) return;

    var key = "blkout_goal_model_" + CACHE_VERSION + "_" + iso;
    try {
      localStorage.setItem(key, JSON.stringify({ goalCents: goalCents, ts: Date.now() }));
    } catch (e) {}
  }

  function buildMsgUSD(post, pre) {
    var shipRemaining = Math.max(0, CONFIG.USD_SHIP_CENTS - post);
    var modelRemaining = Math.max(0, CONFIG.USD_MODEL_CENTS - pre);

    var vars = {
      shipRemaining: formatMoneyIntl(shipRemaining, "USD"),
      modelRemaining: formatMoneyIntl(modelRemaining, "USD"),
      labelShip: CONFIG.labelShip,
      labelModel: CONFIG.labelModel
    };

    if (post < CONFIG.USD_SHIP_CENTS) {
      return template(CONFIG.msgBeforeShip, vars);
    }
    if (pre < CONFIG.USD_MODEL_CENTS) {
      return template(CONFIG.msgAfterShipBeforeModel, vars);
    }
    return template(CONFIG.msgAfterModel, vars);
  }

  // USD: one bar, midpoint is SHIPPING (POST), endpoint is MODEL (PRE)
  function renderUSDSingleBar(el, cart) {
    var post = totalPostDiscount(cart);      // shipping progress uses POST
    var pre = sumOriginalPreDiscount(cart);  // model progress uses PRE

    // Fill:
    // - before ship: 0%..50% based on POST/$ship
    // - after ship:  50%..100% based on PRE/$model
    var fillPct;
    if (post < CONFIG.USD_SHIP_CENTS) {
      fillPct = clamp((post / CONFIG.USD_SHIP_CENTS) * 50, 0, 50);
    } else {
      fillPct = 50 + clamp((pre / CONFIG.USD_MODEL_CENTS) * 50, 0, 50);
    }

    var shipDone = post >= CONFIG.USD_SHIP_CENTS;
    var modelDone = pre >= CONFIG.USD_MODEL_CENTS;

    var msg = buildMsgUSD(post, pre);

    var html = [];
    html.push('<div class="cdp-row"><div class="cdp-msg">' + msg + "</div></div>");

    html.push('<div class="cdp-bar cdp-bar--markers">');
    html.push('  <div class="cdp-fill" style="width:' + fillPct.toFixed(0) + '%"></div>');

    // Icon dot at 50%
    html.push(
      '  <span class="cdp-dot ' + (shipDone ? 'is-complete' : '') + '" style="left:50%" title="' + CONFIG.labelShip + '" aria-hidden="true">' +
      ICON_TRUCK +
      "</span>"
    );

    // Icon dot at 100%
    html.push(
      '  <span class="cdp-dot cdp-dot--end ' + (modelDone ? 'is-complete' : '') + '" style="left:100%" title="' + CONFIG.labelModel + '" aria-hidden="true">' +
      ICON_GIFT +
      "</span>"
    );

    html.push("</div>");

    // Labels under the bar
    html.push('<div class="cdp-labels cdp-labels--named">');
    html.push(
      '  <span class="cdp-label cdp-label--mid" style="left:50%"><span class="cdp-label-text">' +
      CONFIG.labelShip +
      "</span></span>"
    );
    html.push(
      '  <span class="cdp-label cdp-label--end" style="left:100%"><span class="cdp-label-text">' +
      CONFIG.labelModel +
      "</span></span>"
    );
    html.push("</div>");

    el.innerHTML = html.join("");
  }

  // Model-only bar (PRE). Icon dot at end + label under end.
  function renderModelOnly(el, cart, iso, goalCents) {
    var pre = sumOriginalPreDiscount(cart);
    var pct = clamp((pre / goalCents) * 100, 0, 100);
    var remaining = Math.max(0, goalCents - pre);

    // Keep your existing message structure but use labelModel for the name
    var msg = remaining > 0
      ? (formatMoneyIntl(remaining, iso) + " left for " + CONFIG.labelModel)
      : (CONFIG.labelModel + " unlocked");

    var done = pre >= goalCents;

    var html = [];
    html.push('<div class="cdp-row"><div class="cdp-msg">' + msg + "</div></div>");

    html.push('<div class="cdp-bar cdp-bar--markers">');
    html.push('  <div class="cdp-fill" style="width:' + pct.toFixed(0) + '%"></div>');
    html.push(
      '  <span class="cdp-dot cdp-dot--end ' + (done ? 'is-complete' : '') + '" style="left:100%" title="' + CONFIG.labelModel + '" aria-hidden="true">' +
      ICON_GIFT +
      "</span>"
    );
    html.push("</div>");

    html.push('<div class="cdp-labels cdp-labels--named">');
    html.push(
      '  <span class="cdp-label cdp-label--end" style="left:100%"><span class="cdp-label-text">' +
      CONFIG.labelModel +
      "</span></span>"
    );
    html.push("</div>");

    el.innerHTML = html.join("");
  }

  function renderModelWithConversion(el, cart, iso) {
    // USD model is fixed, no SF call needed
    if (iso === "USD") {
      renderModelOnly(el, cart, "USD", CONFIG.USD_MODEL_CENTS);
      return;
    }

    var cachedGoal = readCachedGoal(iso);
    if (cachedGoal) {
      renderModelOnly(el, cart, iso, cachedGoal);
      return;
    }

    computePresentmentRate(iso)
      .then(function (rateObj) {
        var rawGoal = Math.round(CONFIG.USD_MODEL_CENTS * rateObj.rate);
        var goal = floorToDollar(rawGoal);

        if (!goal || goal <= 0) {
          hideBar(el);
          return;
        }

        writeCachedGoal(iso, goal);

        console.log("BLKOUT goal computed", {
          iso: iso,
          anchorVariantId: rateObj.anchorVariantId,
          countryUsed: rateObj.targetCountry,
          rate: rateObj.rate,
          goalCents: goal
        });

        renderModelOnly(el, cart, iso, goal);
      })
      .catch(function (err) {
        console.log("BLKOUT SF failed / unsupported currency", err);
        hideBar(el);
      });
  }

  function render(cart) {
    var el = document.getElementById(mountId);
    if (!el) return;

    showBar(el);

    var sf = getSfConfig();
    var iso = cartCurrency(cart);

    // If currency is not approved, hide entire promo bar.
    if (!APPROVED_MODEL_CURRENCIES[iso]) {
      hideBar(el);
      return;
    }

    // US + USD: show split bar (Shipping at 50%, Model at 100%)
    if (iso === "USD" && sf.country === "US") {
      renderUSDSingleBar(el, cart);
      return;
    }

    // All other approved currencies (including USD outside US): model only (PRE-based)
    renderModelWithConversion(el, cart, iso);
  }

  function refresh() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function init() {
    function tryRefresh() {
      var el = document.getElementById(mountId);
      if (!el) { setTimeout(tryRefresh, 50); return; }
      refresh();
    }
    tryRefresh();

    var drawer =
      document.querySelector("cart-drawer-component") ||
      document.querySelector("dialog.cart-drawer") ||
      document.querySelector("cart-drawer");

    if (drawer) {
      var obs = new MutationObserver(function () { refresh(); });
      obs.observe(drawer, { childList: true, subtree: true });
    }

    window.addEventListener("popstate", function () { refresh(); });

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
